module.exports = __webpack_public_path__ + "img/highland_web.185eec8e.png";